// NotFound.js
import React from "react";
import { Box, Typography } from "@mui/material";
import { ErrorOutline } from "@mui/icons-material";

const NotFound = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="calc(100vh - 64px)">
      <ErrorOutline color="error" fontSize="large" />
      <Typography variant="h5" component="div" mt={2}>
        404 - Page Not Found
      </Typography>
      <Typography variant="body1" color="textSecondary" mt={1}>
        The page you are looking for does not exist.
      </Typography>
    </Box>
  );
};

export default NotFound;
